import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import { FilledBadgeTrickIcon } from '../svgIcon/filled';

const useStyles = makeStyles({
  tooltip: {},
  popper: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: '#333333',
      color: '#FBFBFB',
      fontSize: '12px',
      lineHeigth: '16px',
      fontWeight: '500',
      borerRadius: '4px',
      padding: '6px 10px',
    },
  },
});

const BlueTick = (_: React.SVGProps<SVGSVGElement> & { scale?: string }) => {
  const classes = useStyles();

  const { scale, ...iconProps } = _;

  return (
    <Tooltip
      placement="top-start"
      title={'Doccen đã xác nhận rằng tài khoản này là thật.'}
      classes={{
        popper: classes.popper,
      }}
      className={scale || '!scale-75'}
    >
      <div>
        <FilledBadgeTrickIcon {...iconProps} className="text-Primary/Main" />
      </div>
    </Tooltip>
  );
};

export default BlueTick;
